import React, { Component } from 'react';
import DataTables from '../DataTables';
import Cookie from 'js-cookie';
import { Config } from '../../config/config';
import Menu from '../Menu';
import Header from '../Header';
import Footer from '../Footer';
import { Navigate } from 'react-router-dom';
import { ApiGateWay } from '../../ApiGateWay/ApiGateWay';
import Spinner from '../../UIComponents/Spinner/Spinner';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TRAINING_DOCUMENTS } from './TrainingData';
import { RETAIL_TRAINING_STATUS } from '../../Utilities/AppData/Training/RetailTrainingGlobal';
import { LOGISTICS_TRAINING_STATUS } from '../../Utilities/AppData/Training/LogisticsTrainingGlobal';
import MessageBoxForInvalidPage from '../../UIComponents/MessageBox/MessageBoxForInvalidPage';
import LZString from 'lz-string';

class Training extends Component {
  constructor(props) {
    super(props);
    const config = JSON.parse(Config);
    let stores = JSON.parse(localStorage.getItem('storeData'));
    let wareHouses = JSON.parse(localStorage.getItem('warehouseData'));
    // let stores = JSON.parse(Cookie.get('stores'));
    // let wareHouses = JSON.parse(Cookie.get('warehouses'));
    localStorage.removeItem('curStoreID');
    localStorage.removeItem('tabName');
    localStorage.removeItem('store_tabName');
    localStorage.removeItem('warehouse_tabName');
    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    const menu = user['moduleAccess'];
    let date = new Date();
    date.setDate(date.getDate() + 30);
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);
    let year = date.getFullYear();
    let dayUpTo = year + '-' + month + '-' + day;

    var daynow = new Date();
    daynow.setDate(daynow.getDate());
    var dateStringNow = daynow.toISOString().split('T')[0];
    let storeid;
    var dayst = new Date();
    dayst.setDate(dayst.getDate() - 30);
    var dateString = dayst.toISOString().split('T')[0];
    let currDate = new Date();
    currDate.setDate(date.getDate() + 1);
    let month1 = ('0' + (currDate.getMonth() + 1)).slice(-2);
    let day1 = ('0' + currDate.getDate()).slice(-2);
    let year1 = currDate.getFullYear();
    let presentDate = year1 + '-' + month1 + '-' + day1;

    this.state = {
      title: 'Training',
      data: [],
      alert: '',
      incType: '',
      //storeValue: stores[0].storeId,
      storeValue: null,
      storeValue1: null,
      storeSelected: false,
      closure: '',
      stores,
      wareHouses,
      user: menu,
      pageAllowed: false,
      modalOpen: false,
      visible: false,
      tableVisible: false,
      month: config['month'],
      currentMonth: new Date().getMonth() + 1,
      currentyear: new Date().getFullYear(),
      dayUpTo,
      presentDate,
      years: config['years'],
      FromDate: dateString,
      ToDate: dateStringNow,
      codeJson: [],
      trainingCodeJson: [],
      submittedByCodeJson: [],
      message: '',
      apiInterface: config['api'],
      proxyjson: [],
      proxyjson1: [],
      loading: false,
      submittedBy: '',
      activeTab: 0,
      user_id: '',
      userIdName:'',
      trainingId: '',
      userName: null,
      userSelected: false,
      storeData: [],
      multiSearch: '',
      dataVisible: false,
      allStores: [],
      form: false,
      display: false,
      userval: false,
      trainingVal: false,
      storeid,
      type: '',
    };
  }

  handleStoreValue = (e) => {
    if (this.state.activeTab == 1) {
      this.setState({
        storeValue: e.target.value,
        codeJson: [],
        proxyjson1: [],
        trainingId: '',
        trainingCodeJson: [],
        display: true,
        trainingVal: false,
        userval: false,
      });
    } else if (this.state.activeTab == 0) {
      this.setState({
        storeValue1: e.target.value,
        display: true,
        userval: false,
      });
    }
    if (this.state.activeTab == 1) {
      ApiGateWay.Get(
        this.state.apiInterface + '/listOfTrainings?storeId=' + e.target.value
      )
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            this.setState({
              loading: false,
              modalOpen: true,
              message:
                'Your session has been expired and you will be redirected to the login page!!',
            });
            setTimeout(() => {
              return (window.location = '/');
            }, 4000);
          }

          this.setState({
            trainingCodeJson: response,
            dataVisible: false,
            trainingVal: true,
            storeSelected: true,
          });
        })
        .catch((error) => {
          this.setState({
            display: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
      ApiGateWay.PostEmp(
        this.state.apiInterface + '/fetchEmpInfo?storeId=' + e.target.value
      )
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            this.setState({
              loading: false,
              modalOpen: true,
              message:
                'Your session has been expired and you will be redirected to the login page!!',
            });
            setTimeout(() => {
              return (window.location = '/');
            }, 4000);
          }

          this.setState({
            codeJson: response,
            display: false,
            userval: true,
            dataVisible: false,
            storeSelected: true,
          });
        })
        .catch((error) => {
          this.setState({
            display: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    } else {
      this.state.stores.forEach((element) => {
        if (e.target.value == element.storeId) {
          this.setState({ type: 'store', display: false }, function () {
            this.handleSelect(
              this.state.activeTab,
              this.state.storeValue1,
              this.state.currentMonth,
              this.state.currentyear,
              this.state.type
            );
          });
        }
      });
      this.state.wareHouses.forEach((element) => {
        if (e.target.value == element.storeId) {
          this.setState({ type: 'warehouse', display: false }, function () {
            this.handleSelect(
              this.state.activeTab,
              this.state.storeValue1,
              this.state.currentMonth,
              this.state.currentyear,
              this.state.type
            );
          });
        }
      });
    }
  };

  // alert(JSON.stringify(this.state.stores));

  handleUserChange = (e) => {
    let sumSt = e.target.value;
    let reSt = sumSt.split(' ');

    this.setState({
      user_id: reSt[0],
      userName: reSt[1],
      userIdName: sumSt,
      display: false,
      userval: true,
    });
  };
  handleTrainingNameChange = (e) => {
    this.setState({
      trainingId: e.target.value,
      display: false,
    });
  };

  handleClick = () => {
    if (this.state.storeValue === '' || this.state.storeValue === null) {
      toast.error('Please select the store', {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else if (this.state.trainingCodeJson === null) {
      toast.error('Please select the user', {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      this.setState({
        loading: true,
      });
      TRAINING_DOCUMENTS(
        '/loadTrainings',
        this.state.storeValue,
        this.state.user_id,
        this.state.trainingId
      )
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            this.setState({
              loading: false,
              modalOpen: true,
              message:
                'Your session has been expired and you will be redirected to the login page!!',
            });
            setTimeout(() => {
              return (window.location = '/');
            }, 4000);
          }
          this.setState({
            proxyjson1: response,
            display: false,
            loading: false,
          });
        })
        .catch((error) => {
          this.setState({
            display: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    }
  };
  handleMonthChange = (e) => {
    this.setState({
      currentMonth: e.target.value,
    });

    this.handleSelect(
      this.state.activeTab,
      this.state.storeid,
      e.target.value,
      this.state.currentyear,
      this.state.type
    );
  };

  handleYearChange = (e) => {
    this.setState({
      currentyear: e.target.value,
    });

    this.handleSelect(
      this.state.activeTab,
      this.state.storeid,
      this.state.currentMonth,
      e.target.value,
      this.state.type
    );
  };

  handleSelect(index, id, month, year, type) {
    localStorage.setItem('activeTabName', index);

    this.setState({
      activeTab: index, //localStorage.getItem('activeTabName'),
      display: true,
      storeid: id,
    });

    if (index == 0) {
      if (type == 'store') {
        RETAIL_TRAINING_STATUS('/retailTrainingStatus', month, year, id)
          .then((response) => {
            this.setState({
              proxyjson: response,
              display: false,
            });
          })
          .catch((error) => {
            this.setState({
              display: false,
              modalOpen: true,
              message: 'Unable to retrieve the data. Please try again later',
            });
          });
      } else if (type == 'warehouse') {
        LOGISTICS_TRAINING_STATUS('/warehouseTrainingStatus', month, year, id)
          .then((response) => {
            this.setState({
              proxyjson: response,
              display: false,
            });
          })
          .catch((error) => {
            this.setState({
              display: false,
              modalOpen: true,
              message: 'Unable to retrieve the data. Please try again later',
            });
          });
      } else this.setState({ display: false });
    } else if (index === 1) {
      this.setState({ display: false, form: true });
    }
  }

  componentDidMount() {
    let future = this.state.user;

    let pageAllow = false;

    future.map((val, index) =>
      val.value == 1
        ? !val.featureAccess
          ? val.featureName == 'Training'
            ? (pageAllow = true)
            : ''
          : ''
        : ''
    );
    if (pageAllow) {
      this.setState({
        pageAllowed: true,
        loading: true,
      });
      setTimeout(() => {
        this.setState({
          loading: false,
        });
      }, 1000);
      this.setState({
        display: false,
      });
      ApiGateWay.Get(this.state.apiInterface + '/loadStoreInfo')
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            this.setState({
              loading: false,
              modalOpen: true,
              message:
                'Your session has been expired and you will be redirected to the login page!!',
            });
            setTimeout(() => {
              return (window.location = '/');
            }, 4000);
          }
          this.setState({
            allStores: response,
            visible: true,
            display: false,
          });
          Cookie.set('storesAll', response, {
            secure: true,
            sameSite: 'strict',
          });
        })
        .catch((error) => {
          this.setState({
            display: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });

      ApiGateWay.PostEmp(this.state.apiInterface + '/fetchEmpInfo')
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            this.setState({
              loading: false,
              modalOpen: true,
              message:
                'Your session has been expired and you will be redirected to the login page!!',
            });
            setTimeout(() => {
              return (window.location = '/');
            }, 4000);
          }
          this.setState({
            submittedByCodeJson: response,
            visible: true,
            display: false,
          });
        })
        .catch((error) => {
          this.setState({
            display: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    } else {
      this.setState({
        pageAllowed: false,
        loading: true,
      });
    }
  }

  render() {
    const {
      currentMonth,
      years,
      month,
      currentyear,
      loading,
      modalOpen,
      message,
      display,
      storeid,
      pageAllowed,
    } = this.state;
    let future = this.state.user;

    let pageAllow = false;
    return (
      <>
        {future.map((val, index) =>
          val.value == 1
            ? !val.featureAccess
              ? val.featureName == 'Training'
                ? (pageAllow = true)
                : ''
              : ''
            : ''
        )}
        {pageAllow === false ? (
        
          <Navigate to="/pageNotAllowed" state={{ id:'Training'}} />
        ) : (
          ''
        )}
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>
        {modalOpen ? (
          <MessageBox
            message={message}
            signout={false}
            onClose={this.handleClose}
          />
        ) : null}

        <div className='wrapper'>
          <Header title={this.state.title} />

          <Menu />
          <div className='content-wrapper'>
            {loading ? (
              <Spinner />
            ) : (
              <section className='content'>
                <ToastContainer
                  position='top-right'
                  autoClose={3000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  className=''
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
                <div className='nav-tabs-custom'>
                  <ul className='nav nav-tabs' id=''>
                    <li
                      className={this.state.activeTab == 0 ? 'active' : ''}
                      onClick={() => this.handleSelect(0, this.state.storeid)}
                    >
                      <a href='#tab_1' data-toggle='tab'>
                        Dashboard
                      </a>
                    </li>
                    <li
                      className={this.state.activeTab == 1 ? 'active' : ''}
                      onClick={() => this.handleSelect(1, this.state.storeid)}
                    >
                      <a href='#tab_2' data-toggle='tab'>
                        Training Status
                      </a>
                    </li>
                  </ul>
                  <div className='tab-content'>
                    <div
                      className={
                        `tab-pane ${this.state.activeTab == 0}` ? `active` : ''
                      }
                      id='tab_1'
                    >
                      <div className='row'>
                        <div className='col-md-9'>
                          {display ? (
                            <Spinner />
                          ) : this.state.activeTab == 0 ? (
                            <>
                              <div className='row'>
                                <div className='col-md-3'>
                                  <form
                                    style={{
                                      background: 'none',
                                      padding: 'none',
                                    }}
                                  >
                                    <div className='form-group'>
                                      <select
                                        className='form-control'
                                        value={currentMonth}
                                        style={{ background: '#f2f2f2' }}
                                        onChange={this.handleMonthChange}
                                      >
                                        <option disabled='true'>Month</option>
                                        {month.map((monthName, monthValue) => (
                                          <option
                                            key={monthName + monthValue}
                                            value={monthValue + 1}
                                          >
                                            {monthName}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </form>
                                </div>

                                <div className='col-md-3'>
                                  <form
                                    style={{
                                      background: 'none',
                                      padding: 'none',
                                    }}
                                  >
                                    <div className='form-group'>
                                      <select
                                        className='form-control  '
                                        value={currentyear}
                                        style={{ background: '#f2f2f2' }}
                                        onChange={this.handleYearChange}
                                      >
                                        <option disabled='true'>Year</option>
                                        {years.map((year, yearValue) => (
                                          <option key={yearValue} value={year}>
                                            {year}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </form>
                                </div>

                                <div className='col-md-4 '>
                                  <form
                                    style={{
                                      background: 'none',
                                      padding: 'none',
                                    }}
                                  >
                                    <div className='form-group'>
                                      <select
                                        className='form-control'
                                        value={storeid}
                                        style={{ background: '#f2f2f2' }}
                                        onChange={this.handleStoreValue}
                                      >
                                        <option selected disabled='true'>
                                          Select a Store
                                        </option>
                                        {this.state.stores
                                          .sort((a, b) =>
                                            a.storeName > b.storeName ? 1 : -1
                                          )
                                          .map((val) => (
                                            <option
                                              key={val.storeId}
                                              value={val.storeId}
                                            >
                                              {val.storeName}
                                            </option>
                                          ))}
                                        {this.state.wareHouses
                                          .sort((a, b) =>
                                            a.storeName > b.storeName ? 1 : -1
                                          )
                                          .map((val) => (
                                            <option
                                              key={val.storeId}
                                              value={val.storeId}
                                            >
                                              {val.storeName}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                  </form>
                                </div>
                              </div>
                              <br /> <br />
                              <table
                                className='table table-bordered table-striped mainGrid safetyTable'
                                id='DataGrid'
                              >
                                <thead
                                  style={{
                                    background: 'rgb(60, 141, 188)',
                                    color: '#fff',
                                  }}
                                >
                                  <tr>
                                    {this.state.proxyjson.thead &&
                                    this.state.activeTab == 0
                                      ? this.state.proxyjson.thead.map(
                                          (val, index) => (
                                            <th key={val + index}>{val} </th>
                                          )
                                        )
                                      : null}
                                  </tr>
                                </thead>
                                <tbody style={{ textAlign: 'left' }}>
                                  {this.state.proxyjson.tbody &&
                                  this.state.activeTab == 0
                                    ? this.state.proxyjson.tbody.map(
                                        (data2, ind) => {
                                          return (
                                            <tr key={data2 + ind}>
                                              {data2.map((data3) => (
                                                // data3.charAt(2) === '-' &&
                                                //   data3.charAt(5) === '-' &&
                                                //   alert(
                                                //     new Date(
                                                //       data3
                                                //         .split('-')
                                                //         .reverse()
                                                //         .join('-')
                                                //     ) <
                                                //       new Date(
                                                //         this.state.presentDate
                                                //       )
                                                //   ),
                                                <td
                                                  className={
                                                    data3.charAt(2) === '-' &&
                                                    data3.charAt(5) === '-' &&
                                                    new Date(
                                                      data3
                                                        .split('-')
                                                        .reverse()
                                                        .join('-')
                                                    ) <
                                                      new Date(
                                                        this.state.presentDate
                                                      )
                                                      ? 'redColorString'
                                                      : data3.charAt(2) ===
                                                          '-' &&
                                                        data3.charAt(5) ===
                                                          '-' &&
                                                        new Date(
                                                          data3
                                                            .split('-')
                                                            .reverse()
                                                            .join('-')
                                                        ) >
                                                          new Date(
                                                            this.state.dayUpTo
                                                          )
                                                      ? 'greenColorString'
                                                      : (data3.charAt(2) ===
                                                          '-' &&
                                                          data3.charAt(5) ===
                                                            '-' &&
                                                          new Date(
                                                            data3
                                                              .split('-')
                                                              .reverse()
                                                              .join('-')
                                                          ) <
                                                            new Date(
                                                              this.state.dayUpTo
                                                            )) ||
                                                        (data3.charAt(2) ===
                                                          '-' &&
                                                          data3.charAt(5) ===
                                                            '-' &&
                                                          new Date(
                                                            data3
                                                              .split('-')
                                                              .reverse()
                                                              .join('-')
                                                          ) >
                                                            new Date(
                                                              this.state.presentDate
                                                            ))
                                                      ? 'orangeColorString'
                                                      : data3 === 'No'
                                                      ? 'redColorString'
                                                      : data3 === 'Yes'
                                                      ? 'greenColorString'
                                                      : ''
                                                  }
                                                >
                                                  {data3}
                                                </td>
                                              ))}
                                            </tr>
                                          );
                                        }
                                      )
                                    : null}
                                </tbody>
                              </table>
                            </>
                          ) : (
                            ''
                          )}
                        </div>
                        <div className='col-md-2'></div>
                      </div>
                      <br />
                      <br />
                    </div>
                    <div
                      className={
                        `tab-pane ${this.state.activeTab == 1}` ? `active` : ''
                      }
                      id='tab_2'
                    >
                      {display ? (
                        <Spinner />
                      ) : this.state.activeTab == 1 ? (
                        <div className='row'>
                          <div className='col-md-9'>
                            <div className='row'>
                              <div className='col-md-3'>
                                <form
                                  style={{
                                    background: 'none',
                                    marginLeft: '-10px',
                                    padding: 'none',
                                  }}
                                >
                                  <div className='form-group '>
                                    <select
                                      className='form-control'
                                      value={this.state.storeValue}
                                      onChange={this.handleStoreValue}
                                      style={{
                                        background: '#f2f2f2',
                                        textTransform: 'capitalize',
                                      }}
                                    >
                                      <option selected disabled='true'>
                                        Select a store
                                      </option>
                                      {/* {this.state.allStores.storeInfo
                                        ? this.state.allStores.storeInfo.map(
                                            (val, index) => (
                                              <option
                                                key={val.storeId}
                                                value={val.storeId}
                                              >
                                                {val.storeName}
                                              </option>
                                            )
                                          )
                                        : null} */}
                                        {this.state.stores
                                          .sort((a, b) =>
                                            a.storeName > b.storeName ? 1 : -1
                                          )
                                          .map((val) => (
                                            <option
                                              key={val.storeId}
                                              value={val.storeId}
                                            >
                                              {val.storeName}
                                            </option>
                                          ))}
                                        {this.state.wareHouses
                                          .sort((a, b) =>
                                            a.storeName > b.storeName ? 1 : -1
                                          )
                                          .map((val) => (
                                            <option
                                              key={val.storeId}
                                              value={val.storeId}
                                            >
                                              {val.storeName}
                                            </option>
                                          ))}
                                    </select>
                                  </div>
                                </form>
                              </div>
                              <div className='col-md-3'>
                                <form
                                  style={{
                                    background: 'none',
                                    marginLeft: '-10px',
                                    padding: 'none',
                                  }}
                                >
                                  <select
                                    className='form-control'
                                    onChange={this.handleTrainingNameChange}
                                    value={this.state.trainingId}
                                    style={{
                                      background: '#f2f2f2',
                                      textTransform: 'capitalize',
                                    }}
                                  >
                                    <option selected value=''>
                                      Select Training
                                    </option>
                                    {this.state.storeSelected &&
                                    this.state.trainingVal &&
                                    this.state.trainingCodeJson
                                      ? this.state.trainingCodeJson.trainingInfo.map(
                                          (val, index) => (
                                            <option
                                              key={val.user_id}
                                              value={val.trainingId}
                                              style={{
                                                textTransform: 'capitalize',
                                              }}
                                            >
                                              {val.trainingName}
                                            </option>
                                          )
                                        )
                                      : null}
                                  </select>
                                </form>
                              </div>
                              <div className='col-md-3'>
                                <form
                                  style={{
                                    background: 'none',
                                    marginLeft: '-10px',
                                    padding: 'none',
                                  }}
                                >
                                  <select
                                    className='form-control'
                                    onChange={this.handleUserChange}
                                    value={
                                      // this.state.user_id +
                                      // ' ' +
                                      // this.state.userName
                                      this.state.userIdName
                                    }
                                    style={{
                                      background: '#f2f2f2',
                                      textTransform: 'capitalize',
                                    }}
                                  >
                                    <option selected value=''>
                                      Select User
                                    </option>
                                    {this.state.storeSelected &&
                                    this.state.userval &&
                                    this.state.codeJson
                                      ? this.state.codeJson.empInfos.map(
                                          (val, index) => (
                                            <option
                                              key={val.user_id}
                                              // value={
                                              //   val.user_id +
                                              //   ' ' +
                                              //   val.givenName
                                              // }
                                              style={{
                                                textTransform: 'capitalize',
                                              }}
                                            >
                                              {val.givenName} {val.surname}
                                            </option>
                                          )
                                        )
                                      : null}
                                  </select>
                                </form>
                              </div>

                              <div className='col-md-2'>
                                <form
                                  style={{
                                    background: 'none',
                                    marginLeft: '-10px',
                                    padding: 'none',
                                  }}
                                >
                                  <button
                                    type='button'
                                    onClick={this.handleClick}
                                    className='btn btn-secondary deca-btn-yellow'
                                  >
                                    SUBMIT
                                  </button>
                                </form>
                              </div>
                            </div>
                          </div>
                          <br />
                          <br />
                          <div style={{ marginLeft: '14px' }}>
                            <table
                              className='table table-bordered table-striped mainGrid safetyTable'
                              id='DataGrid'
                            >
                              <thead
                                style={{
                                  background: 'rgb(60, 141, 188)',
                                  color: '#fff',
                                  marginTop: '-50px',
                                }}
                              >
                                <tr>
                                  {this.state.proxyjson1.thead &&
                                  this.state.activeTab == 1
                                    ? this.state.proxyjson1.thead.map(
                                        (val, index) => (
                                          <th key={val + index}>{val} </th>
                                        )
                                      )
                                    : null}
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.proxyjson1.tbody &&
                                this.state.activeTab == 1
                                  ? this.state.proxyjson1.tbody.map(
                                      (data2, ind) => {
                                        return (
                                          <tr key={data2 + ind}>
                                            {data2.map((data3) => (
                                              <td>{data3}</td>
                                            ))}
                                          </tr>
                                        );
                                      }
                                    )
                                  : null}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                      <br />
                      <br />
                    </div>
                  </div>
                </div>
              </section>
            )}
          </div>

          <Footer />
        </div>
      </>
    );
  }
}

export default Training;
